import UAParser from '@libs/ua-parser-js/index';
class UserAgent extends UAParser {

};
const ua = new UserAgent;
export default ua;
